import {Box, Stack, Typography} from '@mui/material';
import {currency_atom} from 'atoms';
import {get_price_str, prevent_scroll} from 'common';
import {Footer} from 'components/layout/Footer';
import {Header} from 'components/layout/Header';
import Layout from 'components/layout/Layout';
import NavButton from 'components/NavButton';
import OrderTable from 'components/order/OrderTable';
import PullToRefreshBox from 'components/PullToRefreshBox';
import {useClosedOrders} from 'hooks/orderHooks';
import {useBalance} from 'hooks/userHooks';
import {useEffect} from 'react';
import {useRecoilValue} from 'recoil';

export default function HistoryPage() {
	const currency = useRecoilValue(currency_atom);

	const {balance, refresh_forced: refresh_balance} = useBalance();
	const {total_profit, refresh_forced, orders} = useClosedOrders();

	const total_investment = balance - total_profit;

	useEffect(() => {
		refresh_balance();
		refresh_forced();
	}, []);

	return (
		<Layout header={Header} footer={Footer}>
			<Stack width="100%" flex={1} p={1} sx={prevent_scroll} bgcolor="#030303">
				<Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
					<Typography variant="body1">Order History</Typography>

					{false && (
						<Typography variant="body2" color="gray" whiteSpace={{xs: 'pre-wrap', sm: 'nowrap'}}>
							{`Initial Budget\n${get_price_str(total_investment, true)} ${currency}`}
						</Typography>
					)}

					<Stack alignItems="flex-end">
						<Typography variant="body2" color={total_profit >= 0 ? 'green' : 'red'} whiteSpace={{xs: 'pre-wrap', sm: 'nowrap'}}>
							Total Profit
						</Typography>
						<Typography variant="body2" color={total_profit >= 0 ? 'green' : 'red'} whiteSpace={{xs: 'pre-wrap', sm: 'nowrap'}}>
							{`${get_price_str(total_profit, false, 0)} ${currency}`}
						</Typography>
					</Stack>
				</Box>

				<PullToRefreshBox onRefresh={refresh_forced}>
					<OrderTable orders={orders} />
					<NavButton type="HOME" />
				</PullToRefreshBox>
			</Stack>
		</Layout>
	);
}
